/**
 * Janela do relatório a partir do período das menções de um upload.
 *
 * Só texto, sem `Date`: `published_at` é hora de parede da clipadora e a
 * tela não converte fuso (regra de 2026-08-29, `shared/utils/date-range.ts`).
 * Pegar os dez primeiros caracteres (`AAAA-MM-DD`) e montar o texto do
 * `datetime-local` dá o mesmo resultado em qualquer fuso do navegador.
 */
const DAY = /^\d{4}-\d{2}-\d{2}/;

/** Começo do dia da publicação mais antiga ao fim do dia da mais recente.
 *  Devolve `null` se alguma ponta não começa com uma data. */
export function windowFromBounds(
  earliestPublishedAt: string,
  latestPublishedAt: string
): { from: string; to: string } | null {
  const first = DAY.exec(earliestPublishedAt)?.[0];
  const last = DAY.exec(latestPublishedAt)?.[0];
  if (!first || !last) return null;
  return { from: `${first}T00:00`, to: `${last}T23:59` };
}
